import { AxiosBO } from "./axios-bo";

const checkLinkURL = () => {
   if(window.location.href.includes("https://vtrc.redcross.or.th/")){
       return 'https://vtrcapi.redcross.or.th/workforce-api/api/restful/'
   }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
       return 'https://uat-vtrcapi.redcross.or.th/workforce-api/api/restful/'
  }else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
       return 'https://uat-vtrcapi.redcross.or.th/workforce-api/api/restful/'
   }
}

// export default AxiosBO(checkLinkURL())
export default AxiosBO()